import React from 'react';
import styles from './styles/Footer.module.css';

function Footer({ resetCookieConsent }) {
  return (
    <footer className={styles.footer}>
      <p className={styles.footerText}>
        <a href="/impressum" style={{ color: '#333', textDecoration: 'none', marginRight: '15px' }}>
          Impressum
        </a>
        |
        <a href="/datenschutz" style={{ color: '#333', textDecoration: 'none', marginLeft: '15px', }}>
          Datenschutzerklärung
        </a>
      </p>
    </footer>
  );
}

export default Footer;
